module.exports = __webpack_public_path__ + "img/liste-soin-part-3.da9f4836.jpeg";